module.exports = __webpack_public_path__ + "static/img/12areaA_10.386f72f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/12areaA_10.png
// module id = 791
// module chunks = 1